<template>
    <div class="process">
        <div class="process-header">
            <i class="el-icon-arrow-left" @click="increase(-1)"></i>
            <div class="scroll-tabs" ref="scrollTabs">
                <div
                    class="process-header-tab"
                    v-for="(item, index) in processList"
                    :key="item.swapId"
                >
                    <div
                        :class="[
                            'tab-box',
                            { 'active-box': tabActiveIndex === index }
                        ]"
                        @click="tabClick(index, item.swapId)"
                    >
                        <div>
                            {{ item.cardName }}
                        </div>
                        <div class="tab-date">
                            {{ item.opDate.slice(2, 10) || '--' }}
                        </div>
                    </div>
                    <div class="tab-icon" v-if="index < processList.length - 1">
                        <i class="el-icon-caret-right"></i>
                    </div>
                </div>
            </div>
            <i class="el-icon-arrow-right" @click="increase(1)"></i>
        </div>
        <div class="process-content">
            <process-time-line
                ref="processTimeLine"
                :list="processList"
                @changeEyeInfo="changeEyeInfo"
            ></process-time-line>
        </div>
    </div>
</template>

<script>
import { barcodeFullProcessTracking } from '@/modules/sn/api/lcbsManagement.js';
import processTimeLine from './processTimeLine';
import {
    fetchEyeInfo,
    fetchEyeInfoLog
} from '../../../../../api/productProcess.js';
export default {
    components: {
        processTimeLine
    },
    props: {
        barcodeNo: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            tabs: [],
            tabActiveIndex: 0,
            processList: [],
            barcoderocessType: {
                stockOut: {
                    cardKey: 'stockOut',
                    name: '出库'
                },
                stockIn: {
                    cardKey: 'stockIn',
                    name: '入库'
                },
                afterSales: {
                    cardKey: 'afterSales',
                    name: '售后服务'
                }
            }
        };
    },
    mounted() {
        this.getListData(this.barcodeNo);
    },
    methods: {
        tabClick(i, id) {
            this.tabActiveIndex = i;
            this.$refs.processTimeLine.scrollIntoView(id);
        },
        // 0-自减，1-自增
        increase(num) {
            if (num > 0) {
                // if (this.tabActiveIndex < this.processList.length - 1) {
                //     this.tabActiveIndex++;
                this.$refs.scrollTabs.scrollLeft += 90;
                // }
            } else {
                // if (this.tabActiveIndex > 0) {
                //     this.tabActiveIndex--;
                this.$refs.scrollTabs.scrollLeft -= 90;
                // }
            }
        },
        getListData(barcode) {
            if (!barcode) return;
            barcodeFullProcessTracking({ barcodeNo: barcode }).then((res) => {
                if (res && +res.code === 0) {
                    this.setListData(res.data);
                }
            });
        },

        setListData(data) {
            // 来源系统rec_source_sys = CSS 时为售后单，inoutType：IN出库- OUT-出库
            this.processList = data.map((item) => {
                if (item.recSourceSys === 'CSS') {
                    item.config = this.barcoderocessType.afterSales;
                } else if (item.inoutType === 'IN') {
                    item.config = this.barcoderocessType.stockIn;
                } else {
                    item.config = this.barcoderocessType.stockOut;
                }
                item.cardName = this.getCardName(item);

                // 收件人信息 IOXDOX就展示否则不展示
                item.addressEyeShow = false; // 是否显示眼睛内容
                item.phoneEyeShow = false; // 是否显示眼睛内容
                item.addressEyeInfo = item.receiverDetailAddr || ''; // 显示眼睛内容地址
                item.phoneEyeInfo = ''; // 显示眼睛内容地址
                item.textId = 'SID' + item.swapId;
                return item;
            });
            // this.processList = this.processList.slice(0, 4);
            this.handleSort(true);
        },
        getCardName(data) {
            let name = '';
            if (data.config.cardKey === 'afterSales') {
                name = data.config.name;
            } else {
                name = data.inoutTypeName ? data.inoutTypeName : '--';
            }
            return name;
        },
        // 排序
        handleSort(flag) {
            this.processList = this.processList.sort((a, b) => {
                if (flag) {
                    return new Date(a.opDate) - new Date(b.opDate);
                } else {
                    return new Date(b.opDate) - new Date(a.opDate);
                }
            });
        },
        changeEyeInfo(type, no, index) {
            const showKey = type + 'EyeShow';
            const infoKey = type + 'EyeInfo';
            this.processList[index][showKey] =
                !this.processList[index][showKey];
            if (
                !this.processList[index][infoKey] &&
                this.processList[index][showKey]
            ) {
                this.getEyeData(type, no, index);
            }
        },
        getEyeData(type, no, index) {
            fetchEyeInfo({
                sourceBillNo: no,
                isNeedReceiverAddress: type === 'address',
                isNeedReceiverPerson: type === 'phone'
            }).then((res) => {
                const params = {
                    model: '条码流向列表',
                    describe: res.data.receiverMobile,
                    result: res.code === '0' ? 'successful' : 'failed',
                    action: 'acces',
                    url: '/lbcs/bcBarcode/getReceiverDetails'
                };
                fetchEyeInfoLog(params);
                const infoKey = type + 'EyeInfo';
                if (res.code === '0' && res.data) {
                    this.setEyeData(res.data, type, index, infoKey);
                } else {
                    this.processList[index][infoKey] = '';
                }
            });
        },
        setEyeData(data, type, index, infoKey) {
            if (type === 'address') {
                if (!data.receiverFullAddress) {
                    this.$message({
                        showClose: true,
                        message: '无法获取地址信息',
                        type: 'error'
                    });
                }
                this.processList[index][infoKey] =
                    data.receiverFullAddress || '-';
            }
            if (type === 'phone') {
                if (!data.receiverName) {
                    this.$message({
                        showClose: true,
                        message: '无法获取收件人信息',
                        type: 'error'
                    });
                }
                this.processList[index][infoKey] = `${data.receiverName || ''}${
                    data.receiverMobile || ''
                }`;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.process {
    padding: 10px 20px;
    font-size: 12px;

    .process-header {
        display: flex;
        align-items: center;
        .el-icon-arrow-left,
        .el-icon-arrow-right {
            padding: 10px;
            font-size: 18px;
            font-weight: 600;
            &:hover {
                color: #4285f5;
            }
        }
        .el-icon-arrow-left {
            padding-left: 0;
        }
    }
    .scroll-tabs {
        display: flex;
        margin-top: 10px;
        padding-bottom: 10px;
        max-width: 700px;
        overflow-y: hidden;
        overflow-x: scroll;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        overflow: -moz-scrollbars-none; /* Firefox */
        &::-webkit-scrollbar {
            display: none; /* Chrome, Safari and Opera */
        }
    }
    .process-header-tab {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        margin-right: 5px;
        width: 85px;
        .tab-box {
            box-sizing: border-box;
            padding: 6px;
            width: 70px;
            border-radius: 4px;
            border: 1px solid #f5f5f5;
            background: #f5f5f5;
            text-align: center;
        }
        .tab-date {
            margin-top: 5px;
        }
        .active-box {
            background: #ecf3fe;
            border: 1px solid rgba(66, 133, 245, 1);
            color: #4285f5;
        }
        .tab-icon {
            margin-left: 5px;
        }
        .el-icon-caret-right {
            font-size: 16px;
            color: #999999;
        }
    }
    .process-content {
        margin-top: 10px;
    }
}
</style>
